// extracted by mini-css-extract-plugin
export var cancelButton = "_o4-5";
export var content = "_o4-3";
export var createButton = "_o4-6";
export var drawerContainer = "_o4-0";
export var footer = "_o4-2";
export var header = "_o4-1";
export var orderFormColumn = "_o4-4";